<!-- Section Régulation -->
<app-collapse
  [title]="'P00076.status.regulation' | translate"
  [warning]="regulationHasWarning"
>
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="'P00076.status.regulation.vanneremplissage' | translate"
      [value]="getVanneRemplissageValue()"
    />

    <app-display-rubrique-status
      [title]="'P00076.status.regulation.vannevidage' | translate"
      [value]="getVanneVidangeValue()"
    />

    <app-display-rubrique-status-with-warning-and-cta
      [title]="'P00076.status.regulation.remplissagereset' | translate"
      [warning]="getValue('coSAlarmTempsRemplissageMaximum') === 1"
      [ctaText]="'P00076.status.regulation.remplissagereset.cta' | translate"
      [notWarning]="getRemplissageDureeValue()"
      (onPress)="onResetRemplissage()"
    />

    <app-display-rubrique-status-with-warning-and-cta
      [title]="'P00076.status.regulation.vidangereset' | translate"
      [warning]="getValue('coSAlarmTempsVidangeMaximum') === 1"
      [ctaText]="'P00076.status.regulation.vidangereset.cta' | translate"
      [notWarning]="getVidangeDureeValue()"
      (onPress)="onResetVidange()"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00076.status.capteur.niveaumax' | translate"
      [warning]="getValue('coSAlarmNiveauMax') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00076.status.capteur.niveaumax.no' | translate"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00076.status.capteur.niveaumin' | translate"
      [warning]="getValue('coSAlarmNiveauMin') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00076.status.capteur.niveaumin.no' | translate"
    />
  </div>
</app-collapse>

<!-- Section Capteur -->
<app-collapse
  [title]="'P00076.status.capteur' | translate"
  [warning]="capteurHasWarning"
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P00076.status.capteur.batterycapteur' | translate"
      [warning]="getValue('coSAlarmBatterieCapteur') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="getValue('coSMesureBatterieCapteur') + '%'"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00076.status.capteur.signalcapteur' | translate"
      [warning]="getValue('coSAlarmSignalCapteur') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="getValue('coSMesureSignalCapteur') + '%'"
    />

    <app-display-rubrique-status
      [title]="'P00076.status.capteur.signalcapteur.testmode' | translate"
      [value]="getTestModeValue()"
    />
  </div>
</app-collapse>

<!-- Section Compteur -->
<app-collapse [title]="'P00076.status.compteur' | translate">
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="'P00076.status.compteur.volumerempli' | translate"
      [value]="getVolumeRempliValue()"
    />

    <app-display-rubrique-status
      [title]="'P00076.status.compteur.volumvide' | translate"
      [value]="getVolumeVideValue()"
    />

    <app-display-rubrique-status
      [title]="'P00076.status.compteur.nbcommutationremplissage' | translate"
      [value]="getValue('coSCompteurCommutationRemplissage') + ''"
    />

    <app-display-rubrique-status
      [title]="'P00076.status.compteur.nbcommutationvidange' | translate"
      [value]="getValue('coSCompteurCommutationVidange') + ''"
    />
  </div>
</app-collapse>

<!-- Section Produit -->
<app-collapse
  [title]="'P00076.status.produit' | translate"
  [warning]="presenceProduit === 2"
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P00076.status.connexionProduit' | translate"
      [warning]="presenceProduit !== 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00076.status.ok' | translate"
    />

    <app-display-rubrique-status
      [title]="'P00076.statut.tempsSousTension' | translate"
      [value]="transformHourToDayHourLocal(getValue('coSTempssousTension'))"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P00076.status.compteur' | translate"
        [value]="getValue('coSCompteurBouton') + ''"
      />
    }
  </div>
</app-collapse>
